<template>
    <div class="salesroom">
        <div class="search">
            <div class="search-box flex-row">
                <img class="searchImg" :src="search" alt="" >
                <input class="searchVal" placeholder="请输入关键字搜索" v-model="value" type="text">
            </div>
        </div>
        <div class="maps">
            <baidu-map class="map" :center="center" :zoom="15" :keyboard="true" :scroll-wheel-zoom="true" :double-click-zoom="true">
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-control></bm-control>
            </baidu-map>
        </div>
        <ul class="salesItem">
            <li class="item">
                <div class="content">
                    <p>北京大钟寺二店</p>
                    <p>营业时间：08：00-19：00</p>
                    <p>283km|北京市海淀区被三环路23号2层</p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import search from '@/assets/img/search.png';
import contents from '@/components/content';
export default {
    data(){
        return {
            search,
            value:'',
            keyword: '',
            // 百度地图
            centerDialogVisible: false,
            keyword: "",
            center: { lng: 116.404, lat: 39.915 }, //经纬度
            indexAdd: 0,
            editAddressIndex: "",
        }
    }
}
</script>
<style lang="scss" scoped>
.salesroom{
    .search{
        height: 82px;
        background: $ffff;
        .search-box{
            width:670px;
            height:60px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(229,229,229,1);
            border-radius:10px;
            margin:18px 0 0 39px;
            align-items: center;
            .searchImg{
                margin-left: 17px;
                width: 24px;
                height: 24px;
            }
            .searchVal{
                margin-left: 18px;
                width: 600px;
                height: 100%;
            }
        }
    }
  .map {
    width: 100%;
    height: 650px;
    .map_input{
      width:350px;
      height:30px;
    }
    .map_searchinfo{
      width:350px;
      max-height:450px;
      overflow:auto;
    }
  }
  .item{
      border-bottom: 1px solid #f6f6f6; 
      padding: 0 20px 20px 20px;
      .content{
          p{
              margin-top:20px;
          }
      }
  }
}
</style>


